<template>
    <div :class="[wrapperClass, show ? 'lg:visible' : '']" class="tooltip">
        <span :class="[backgroundColor]" class="relative z-40 leading-none flex flex-col p-2 tracking-wide whitespace-nowrap rounded border overflow-hidden text-center shadow text-xs">
            <slot></slot>
        </span>
        <div :class="[backgroundColor]" class="tooltip-arrow"></div>
    </div>
</template>

<script>
export default {
    props: {
        position: {
            default: 'top',
            type: String
        },
        backgroundColor: {
            default: 'bg-gray-900 border-gray-900 text-white'
        }
    },

    computed: {
        wrapperClass() {
            return 'tooltip-' + this.position;
        }
    },

    data() {
        return {
            show: false
        };
    },

    methods: {
        /**
         * Use this method to manually show a tooltip.
         * :hover is handled in app.css
         */
        showTooltip(e) {
            this.show = true;
            setTimeout(() => this.show = false, 1800);
            return null;
        }
    }
};
</script>
